// extracted by mini-css-extract-plugin
module.exports = {"text":"Info_text__3s_XI","icon":"Info_icon__1w_HW"};